// Libraries
import {createContext} from 'react';

type HeadContextType = ((head: unknown) => void) | undefined;

const HeadContext = createContext<HeadContextType>(undefined);

export default HeadContext;
